import script from "./errorNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./errorNotice.vue?vue&type=script&setup=true&lang=ts"

import "./errorNotice.vue?vue&type=style&index=0&id=3b389f63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b389f63"]])

export default __exports__